import videojs from 'video.js';

(function(jQuery) {
    'use strict';
    function ProjectsAbroadVideojs() {
        var fn = {
            init: function() {
                if (
                    typeof videoHeroContentSrc !== 'undefined' &&
                    videoHeroContentSrc != ''
                ) {
                    fn.initHeroWithVideo();
                } else {
                    fn.addHeroFallback();
                }

                if (typeof videoCounter !== 'undefined') {
                    fn.initTextWithVideo();
                }
            },

            renderVimeoVideoHTML: function(arg1, arg2, arg3) {
                let videoSrc = arg2.replace(
                    'https://vimeo.com/',
                    'https://player.vimeo.com/video/'
                );

                return (
                    '<div id="VideoJs--' +
                    arg3 +
                    '" class="video-js video-vimeo-js"><iframe allowfullscreen allow="autoplay; fullscreen" src="' +
                    videoSrc +
                    '?autoplay=1&loop=0&autopause=0" title="Vimeo" style="overflow:hidden;height:100%;width:100%" height="100%" width="100%"/></div>'
                );
            },

            // arg1 = video poster ; arg2 = video src ; arg3 = video id
            renderVideoHTML: function(arg1, arg2, arg3) {
                if (arg2.toLowerCase().indexOf('vimeo') > -1) {
                    return fn.renderVimeoVideoHTML(arg1, arg2, arg3);
                }

                return (
                    '<video id="VideoJs--' +
                    arg3 +
                    '" class="video-js" ' +
                    'poster=" ' +
                    arg1 +
                    ' " ' +
                    "data-setup='{ }'>" +
                    '\t<source src="' +
                    arg2 +
                    '" type="video/mp4" /> \n' +
                    '\t\t<p class="vjs-no-js">To view this video please enable JavaScript, and consider upgrading to a web browser that <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a></p>\n' +
                    '</video>'
                );
            },

            initHeroWithVideo: function() {
                let videoHeroModalTarget = '';
                let videoHeroPosterSrc = '';
                let videoHeroHtml = '';

                for (let key in videoHeroContentSrc) {
                    videoHeroModalTarget = '.VideoFire--hero-' + key;

                    if (videoHeroContentSrc[key] == '') {
                        jQuery(videoHeroModalTarget).addClass('Fallback');
                    } else {
                        jQuery(videoHeroModalTarget).removeClass('Fallback');
                    }

                    jQuery(videoHeroModalTarget).on('click', function(event) {
                        event.preventDefault();
                        videoHeroContentSrc[key],
                            (videoHeroHtml = fn.renderVideoHTML(
                                videoHeroPosterSrc,
                                videoHeroContentSrc[key],
                                'hero-' + key
                            ));
                        jQuery(
                            '.ModalVideo--hero-' + key + ' .modal-body'
                        ).append(videoHeroHtml);
                        jQuery('.ModalVideo--hero-' + key).modal('show');
                    });

                    jQuery('.ModalVideo--hero-' + key).on(
                        'shown.bs.modal',
                        function() {
                            jQuery('.modal-backdrop').hide();
                            videojs('#VideoJs--hero-' + key, {
                                controls: true,
                                autoplay: true,
                                preload: 'auto',
                                fluid: true,
                            });
                        }
                    );

                    jQuery('.ModalVideo--hero-' + key).on(
                        'hidden.bs.modal',
                        function() {
                            var video_player = videojs('#VideoJs--hero-' + key);
                            video_player.dispose();
                        }
                    );
                }
            },

            initTextWithVideo: function() {
                let videoCurrent = [];
                let videoModalTarget = '';
                let videoPosterSrc = '';
                let videoHtml = '';

                for (let i = 1; i <= videoCounter; i++) {
                    if (jQuery('.VideoUrl--page-' + i).length) {
                        videoCurrent[i] = jQuery('.VideoUrl--page-' + i).val();
                        videoModalTarget = '.VideoFire--' + i;

                        if (videoCurrent[i] == '') {
                            jQuery(videoModalTarget).addClass('Fallback');
                        } else {
                            jQuery(videoModalTarget).removeClass('Fallback');
                        }

                        jQuery(videoModalTarget).on('click', function(event) {
                            event.preventDefault();

                            videoHtml = fn.renderVideoHTML(
                                videoPosterSrc,
                                videoCurrent[i],
                                i
                            );
                            jQuery('.ModalVideo--' + i + ' .modal-body').append(
                                videoHtml
                            );
                            jQuery('.ModalVideo--' + i).modal('show');
                        });

                        jQuery('.ModalVideo--' + i).on(
                            'shown.bs.modal',
                            function() {
                                jQuery('.modal-backdrop').hide();
                                videojs('#VideoJs--' + i, {
                                    controls: true,
                                    autoplay: true,
                                    preload: 'auto',
                                    fluid: true,
                                });
                            }
                        );

                        jQuery('.ModalVideo--' + i).on(
                            'hidden.bs.modal',
                            function() {
                                var video_player = videojs('#VideoJs--' + i);
                                video_player.dispose();
                            }
                        );
                    } else {
                        jQuery('.VideoFire').addClass('Fallback');
                    }
                }
            },

            addHeroFallback: function() {
                jQuery('.VideoFire').addClass('Fallback');
            },
        };

        fn.init();
    }
    new ProjectsAbroadVideojs();
})($);
